import React from 'react'
import { Table, Spinner } from 'react-bootstrap'
import './kycStyle.css'
import './SearchResultsTable.css'
type SearchResultTableProps = {
  showProgress: boolean
  handleXpertBusinessLoadReport: (business: any) => void
  xpertBusinesses: { businessName: string; registrationNo: string }[]
}
export const SearchResultTable: React.FC<SearchResultTableProps> = ({
  showProgress,
  handleXpertBusinessLoadReport,
  xpertBusinesses,
}) => {
  return (
    <div
      className="kyc-results-table-container"
      style={{ height: '300px', overflow: '20' }}
    >
      <table>
        <thead>
          <tr>
            <td
              style={{
                backgroundColor: 'rgb(12, 135, 169)',
                color: 'rgb(255, 255, 255)',
                position: 'sticky',
                top: 0,
              }}
            >
              Business name
            </td>
            <td
              style={{
                backgroundColor: 'rgb(12, 135, 169)',
                color: 'rgb(255, 255, 255)',
                position: 'sticky',
                top: 0,
              }}
            >
              Registration #
            </td>
          </tr>
        </thead>
        <tbody>
          {xpertBusinesses.map((business) => {
            return (
              <tr
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  handleXpertBusinessLoadReport(business)
                }}
              >
                <td>{business.businessName}</td>
                <td>{business.registrationNo}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
      {showProgress && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
    </div>
  )
}

export default SearchResultTable
